<script setup lang="ts">
import {ref, onMounted, computed,} from 'vue'

import FormSection from '@/components/forms/FormSection.vue'
import FormInputText from '@/components/inputs/FormInputText.vue'
import FormDropdown from '@/components/inputs/FormDropdown.vue'
import FormCalendar from '@/components/inputs/FormCalendar.vue'
import type { Supplier } from '@/types/supplier-types'
import { getSupplierList } from '@/api/suppliers'
import FormTextArea from '@/components/inputs/FormTextArea.vue'

const props = defineProps<{
    values: any
    onSubmit: () => void
    setErrors: (errors: any) => void
    batchNumber: string
    finishingSupplierId: string
}>()

const suppliers = ref<Supplier[] | undefined>()

const supplierName = computed(() => {
  return suppliers.value?.find(supplier => supplier.id === props.finishingSupplierId)?.name || 'Unknown Supplier'
})

onMounted(async () => {
  suppliers.value = await getSupplierList()
})
</script>

<template>
 <form @submit.prevent="onSubmit">
    <FormSection title="">
        <FormInputText
          label="Packing List ID"
          inputName="packingListId"
          id="packingListId"
          placeholder="This field will be pre-filled by the system"
          :disabled="true"
        />
        <FormCalendar
          label="Packing List Date"
          inputName="packingListDate"
          id="packingListDate"
          placeholder="Enter packing list date"
          v-model="values.packingListDate"
        />
        <FormInputText
          label="Batch Number"
          inputName="batchNumber"
          id="batchNumber"
          :disabled="true"
          :placeholder="batchNumber"
        />
        <FormInputText
          label="Supplier"
          inputName="finishingSupplierId"
          id="finishingSupplierId"
          :disabled="true"
          :placeholder="supplierName"
        />
    </FormSection>
    <FormTextArea
        label="Notes"
        inputName="notes"
        id="notes"
        class="w-full"
      />
    </form>
</template>